import Preloader from '@/components/Preloader/Preloader'
import styles from './Layout.module.scss'
import { useContext, useEffect, useRef } from 'react'
import Navigation from '@/components/Navigation/Navigation'
import PageTransition from '@/components/PageTransition/PageTransition'
import Cursor from '@/components/Cursor/Cursor'
import ProductGalleryNav from '@/sections/ProductGalleryNav/ProductGalleryNav'
import ProductPageUi from '@/sections/ProductPageUi/ProductPageUi'
import useCurrentPage from '@/hooks/use-current-page'
import ZoomImage from '@/components/ZoomImage/ZoomImage'
import useStore from '@/store'
import ProductPageGalleryView from '@/components/ProductPageGalleryView/ProductPageGalleryView'
import { ScrollContext } from '@/context/Scroll'
import ScrollDisabler from '@/sections/ScrollDisabler/ScrollDisabler'
import DebugMobileText from '@/sections/DebugMobileText/DebugMobileText'

export const SCROLL_CONTAINER_CLASS = styles.scrollContainer
export const SCROLL_CONTENT_CLASS = styles.scrollContainerInner
export const MAIN_FADE_IN_DURATION = 0.3
export const MAIN_ID = 'main'

const Layout = ({ children }) => {
  const mainRef = useRef()
  const scrollContentRef = useRef()
  const { isProductInnerPage } = useCurrentPage()
  const productPageData = useStore(state => state.productPageData)
  const zoomImageOpen = useStore(state => state.zoomImageOpen)
  const { scroll, initScroll } = useContext(ScrollContext)

  useEffect(() => {
    initScroll()
  }, [initScroll])

  useEffect(() => {
    if (!scroll) return
    scroll[zoomImageOpen ? 'stop' : 'start']()
  }, [zoomImageOpen, scroll])

  return (
    <>
      {process.env.NEXT_PUBLIC_DISABLE_PRELOADER !== 'true' && <Preloader />}
      <Navigation />
      <ProductGalleryNav />
      <ProductPageGalleryView />
      <ProductPageUi />
      <ScrollDisabler />
      <DebugMobileText />
      {isProductInnerPage && productPageData?.productData?.zoomImage && <ZoomImage />}
      <main
        id={MAIN_ID}
        ref={mainRef}
        className={SCROLL_CONTAINER_CLASS}
        data-themed="background-color"
      >
        <div
          ref={scrollContentRef}
          className={SCROLL_CONTENT_CLASS}
        >
          <PageTransition>{children}</PageTransition>
        </div>
      </main>
      <Cursor />
    </>
  )
}

Layout.displayName = 'Layout'

export default Layout
